export default __webpack_public_path__ + "static/media/2526 knife block A top.0baf5321.png";